// Wrapper responsive - Affiche Desktop ou Mobile selon la taille d'écran
import { useState, useEffect } from 'react';

export default function ResponsivePageWrapper({ DesktopComponent, MobileComponent }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <MobileComponent /> : <DesktopComponent />;
}
